var render = function render(){
  var _vm$resi, _vm$resi2, _vm$resi3, _vm$resi4, _vm$resi4$invoice_cus, _vm$resi5, _vm$resi6, _vm$resi6$invoice_cus, _vm$resi7, _vm$resi8, _vm$resi9, _vm$resi10, _vm$resi11, _vm$resi12, _vm$resi13, _vm$resi14, _vm$resi15, _vm$resi16, _vm$resi17, _vm$resi18;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen bg-gray-100"
  }, [_c('div', {
    staticClass: "mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-start mb-6 mdmax:flex-col gap-4"
  }, [_c('div', [_c('button', {
    staticClass: "text-sm text-neutral-600 hover:text-neutral-800 mb-2",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/invoices/resi');
      }
    }
  }, [_vm._v(" ← Kembali ")]), _c('h1', {
    staticClass: "text-xl font-bold text-neutral-800"
  }, [_vm._v("Resi Detail")]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(" " + _vm._s(((_vm$resi = _vm.resi) === null || _vm$resi === void 0 ? void 0 : _vm$resi.resi_number) || "-") + " • " + _vm._s(_vm.formatDate((_vm$resi2 = _vm.resi) === null || _vm$resi2 === void 0 ? void 0 : _vm$resi2.date)) + " ")])]), _c('div', {
    staticClass: "flex gap-2"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-white text-neutral-700 border border-neutral-300 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.openEditResiModal
    }
  }, [_vm._v(" Edit Resi ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.openDeleteResiModal
    }
  }, [_vm._v(" Delete Resi ")])])]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-6"
  }, [_c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Customer")]), _c('p', {
    staticClass: "text-neutral-800 font-bold"
  }, [_vm._v(" " + _vm._s(((_vm$resi3 = _vm.resi) === null || _vm$resi3 === void 0 ? void 0 : _vm$resi3.customer_name) || ((_vm$resi4 = _vm.resi) === null || _vm$resi4 === void 0 ? void 0 : (_vm$resi4$invoice_cus = _vm$resi4.invoice_customer) === null || _vm$resi4$invoice_cus === void 0 ? void 0 : _vm$resi4$invoice_cus.customer_name) || "-") + " ")]), _c('p', {
    staticClass: "text-neutral-500 text-sm"
  }, [_vm._v(" " + _vm._s(((_vm$resi5 = _vm.resi) === null || _vm$resi5 === void 0 ? void 0 : _vm$resi5.customer_address) || ((_vm$resi6 = _vm.resi) === null || _vm$resi6 === void 0 ? void 0 : (_vm$resi6$invoice_cus = _vm$resi6.invoice_customer) === null || _vm$resi6$invoice_cus === void 0 ? void 0 : _vm$resi6$invoice_cus.customer_address) || "-") + " ")])]), _c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Pricing")]), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Destination")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(((_vm$resi7 = _vm.resi) === null || _vm$resi7 === void 0 ? void 0 : _vm$resi7.destination) || "-"))])]), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Unit Price")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.formatCurrency((_vm$resi8 = _vm.resi) === null || _vm$resi8 === void 0 ? void 0 : _vm$resi8.unit_price)))])]), _c('div', {
    staticClass: "flex justify-between items-center mt-1"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Minimum Weight")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s((_vm$resi9 = _vm.resi) !== null && _vm$resi9 !== void 0 && _vm$resi9.minimum_weight ? _vm.resi.minimum_weight + ' Kg' : '-'))])]), _c('div', {
    staticClass: "flex justify-between items-center mt-1"
  }, [_c('span', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Total Price")]), _c('span', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.formatCurrency((_vm$resi10 = _vm.resi) === null || _vm$resi10 === void 0 ? void 0 : _vm$resi10.total_price)))])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('span', {
    staticClass: "px-2 py-1 rounded text-xs font-medium",
    class: (_vm$resi11 = _vm.resi) !== null && _vm$resi11 !== void 0 && _vm$resi11.eligible ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
  }, [_vm._v(" " + _vm._s((_vm$resi12 = _vm.resi) !== null && _vm$resi12 !== void 0 && _vm$resi12.eligible ? "Eligible" : "Not eligible") + " ")])])]), _c('div', {
    staticClass: "bg-white rounded-lg p-4 shadow-sm"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-2"
  }, [_vm._v("Flags")]), _c('div', {
    staticClass: "grid grid-cols-1 gap-1 text-sm text-neutral-700"
  }, [_c('span', [_vm._v("has_weight_detail: " + _vm._s((_vm$resi13 = _vm.resi) !== null && _vm$resi13 !== void 0 && _vm$resi13.has_weight_detail ? "✓" : "—"))]), _c('span', [_vm._v("has_white_receipt: " + _vm._s((_vm$resi14 = _vm.resi) !== null && _vm$resi14 !== void 0 && _vm$resi14.has_white_receipt ? "✓" : "—"))]), _c('span', [_vm._v("has_blue_receipt: " + _vm._s((_vm$resi15 = _vm.resi) !== null && _vm$resi15 !== void 0 && _vm$resi15.has_blue_receipt ? "✓" : "—"))]), _c('span', [_vm._v("has_delivery_order: " + _vm._s((_vm$resi16 = _vm.resi) !== null && _vm$resi16 !== void 0 && _vm$resi16.has_delivery_order ? "✓" : "—"))]), _c('span', [_vm._v("is_wooden_packing: " + _vm._s((_vm$resi17 = _vm.resi) !== null && _vm$resi17 !== void 0 && _vm$resi17.is_wooden_packing ? "✓" : "—"))])])])]), _c('div', {
    staticClass: "flex justify-between items-end mb-4 mdmax:flex-col gap-3"
  }, [_vm._m(0), _c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium",
    on: {
      "click": function ($event) {
        return _vm.openPackageModal('create');
      }
    }
  }, [_vm._v(" + Tambah Package ")])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.packageColumns,
      "list": _vm.packageTableData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex gap-2"
        }, [_c('button', {
          staticClass: "px-3 py-1 rounded bg-neutral-200 text-neutral-700 hover:bg-neutral-300 text-sm",
          on: {
            "click": function ($event) {
              return _vm.openPackageModal('edit', entry);
            }
          }
        }, [_vm._v(" Edit ")]), _c('button', {
          staticClass: "px-3 py-1 rounded bg-red-500 text-white hover:bg-red-600 text-sm",
          on: {
            "click": function ($event) {
              return _vm.openDeletePackageModal(entry);
            }
          }
        }, [_vm._v(" Delete ")])]) : column.field === 'RowNumber' ? _c('span', {
          staticClass: "font-medium"
        }, [_vm._v(" " + _vm._s(entry.RowNumber) + " ")]) : column.field === 'shipment_date' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(entry.shipment_date)) + " ")]) : column.field === 'dimension' ? _c('span', [entry.length && entry.width && entry.height ? _c('span', [_vm._v(" " + _vm._s(entry.length) + " x " + _vm._s(entry.width) + " x " + _vm._s(entry.height) + " ")]) : _c('span', [_vm._v("-")])]) : column.field === 'weight' ? _c('span', [_vm._v(" " + _vm._s(entry.weight || "-") + " ")]) : column.field === 'is_wooden_packing' ? _c('span', [entry.is_wooden_packing ? _c('span', {
          staticClass: "px-2 py-1 rounded text-xs font-medium bg-amber-100 text-amber-700"
        }, [_vm._v(" Packing Kayu ")]) : _c('span', [_vm._v("-")])]) : column.field === 'wooden_packaging_price' ? _c('span', [entry.wooden_packaging_price ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(entry.wooden_packaging_price)) + " ")]) : _c('span', [_vm._v("Rp 0")])]) : column.field === 'price' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.getPackagePrice(entry))) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  }), _vm.packageTableData.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.packageStart) + " - " + _vm._s(_vm.packageEnd) + " dari " + _vm._s(_vm.totalPackages) + " ")]) : _vm._e(), _c('Pagination', {
    attrs: {
      "currentPage": _vm.packagePage,
      "totalCount": _vm.totalPackages,
      "pageSize": _vm.packagePerPage
    },
    on: {
      "onPageChange": _vm.changePackagePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.editResiModalVisible,
      "width": "720px"
    },
    on: {
      "close": _vm.closeEditResiModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v("Edit Resi")]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "md:col-span-2"
  }, [_c('TextField', {
    attrs: {
      "type": "date",
      "label": "Date",
      "required": ""
    },
    model: {
      value: _vm.editResiForm.date,
      callback: function ($$v) {
        _vm.$set(_vm.editResiForm, "date", $$v);
      },
      expression: "editResiForm.date"
    }
  })], 1), _c('TextField', {
    attrs: {
      "label": "Destination",
      "required": "",
      "placeholder": "Destination"
    },
    model: {
      value: _vm.editResiForm.destination,
      callback: function ($$v) {
        _vm.$set(_vm.editResiForm, "destination", $$v);
      },
      expression: "editResiForm.destination"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Resi Number",
      "required": "",
      "placeholder": "Resi number"
    },
    model: {
      value: _vm.editResiForm.resi_number,
      callback: function ($$v) {
        _vm.$set(_vm.editResiForm, "resi_number", $$v);
      },
      expression: "editResiForm.resi_number"
    }
  }), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-3"
  }, [_c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editResiForm.has_weight_detail,
      expression: "editResiForm.has_weight_detail"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editResiForm.has_weight_detail) ? _vm._i(_vm.editResiForm.has_weight_detail, null) > -1 : _vm.editResiForm.has_weight_detail
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.editResiForm.has_weight_detail,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.editResiForm, "has_weight_detail", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.editResiForm, "has_weight_detail", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.editResiForm, "has_weight_detail", $$c);
        }
      }
    }
  }), _vm._v(" has_weight_detail ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editResiForm.has_white_receipt,
      expression: "editResiForm.has_white_receipt"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editResiForm.has_white_receipt) ? _vm._i(_vm.editResiForm.has_white_receipt, null) > -1 : _vm.editResiForm.has_white_receipt
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.editResiForm.has_white_receipt,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.editResiForm, "has_white_receipt", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.editResiForm, "has_white_receipt", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.editResiForm, "has_white_receipt", $$c);
        }
      }
    }
  }), _vm._v(" has_white_receipt ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editResiForm.has_blue_receipt,
      expression: "editResiForm.has_blue_receipt"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editResiForm.has_blue_receipt) ? _vm._i(_vm.editResiForm.has_blue_receipt, null) > -1 : _vm.editResiForm.has_blue_receipt
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.editResiForm.has_blue_receipt,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.editResiForm, "has_blue_receipt", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.editResiForm, "has_blue_receipt", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.editResiForm, "has_blue_receipt", $$c);
        }
      }
    }
  }), _vm._v(" has_blue_receipt ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editResiForm.has_delivery_order,
      expression: "editResiForm.has_delivery_order"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editResiForm.has_delivery_order) ? _vm._i(_vm.editResiForm.has_delivery_order, null) > -1 : _vm.editResiForm.has_delivery_order
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.editResiForm.has_delivery_order,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.editResiForm, "has_delivery_order", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.editResiForm, "has_delivery_order", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.editResiForm, "has_delivery_order", $$c);
        }
      }
    }
  }), _vm._v(" has_delivery_order ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.editResiForm.is_wooden_packing,
      expression: "editResiForm.is_wooden_packing"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editResiForm.is_wooden_packing) ? _vm._i(_vm.editResiForm.is_wooden_packing, null) > -1 : _vm.editResiForm.is_wooden_packing
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.editResiForm.is_wooden_packing,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.editResiForm, "is_wooden_packing", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.editResiForm, "is_wooden_packing", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.editResiForm, "is_wooden_packing", $$c);
        }
      }
    }
  }), _vm._v(" is_wooden_packing ")])])])], 1), _c('div', {
    staticClass: "flex justify-end gap-3 mt-6"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeEditResiModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": !_vm.editResiForm.destination || !_vm.editResiForm.resi_number
    },
    on: {
      "click": _vm.submitEditResi
    }
  }, [_vm._v(" Simpan ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteResiModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteResiModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Delete Resi")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus resi "), _c('strong', [_vm._v(_vm._s((_vm$resi18 = _vm.resi) === null || _vm$resi18 === void 0 ? void 0 : _vm$resi18.resi_number))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteResiModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDeleteResi
    }
  }, [_vm._v(" Hapus ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.packageModalVisible,
      "width": "720px"
    },
    on: {
      "close": _vm.closePackageModal
    }
  }, [_c('div', {
    staticClass: "text-left",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" " + _vm._s(_vm.packageModalMode === "create" ? "Tambah" : "Edit") + " Package ")]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('TextField', {
    attrs: {
      "label": "Shipment Date",
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.packageForm.shipment_date,
      callback: function ($$v) {
        _vm.$set(_vm.packageForm, "shipment_date", $$v);
      },
      expression: "packageForm.shipment_date"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Koli",
      "type": "number",
      "placeholder": "1"
    },
    model: {
      value: _vm.packageForm.koli,
      callback: function ($$v) {
        _vm.$set(_vm.packageForm, "koli", $$v);
      },
      expression: "packageForm.koli"
    }
  }), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.packageForm.is_wooden_packing,
      expression: "packageForm.is_wooden_packing"
    }],
    staticClass: "w-4 h-4",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.packageForm.is_wooden_packing) ? _vm._i(_vm.packageForm.is_wooden_packing, null) > -1 : _vm.packageForm.is_wooden_packing
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.packageForm.is_wooden_packing,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.packageForm, "is_wooden_packing", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.packageForm, "is_wooden_packing", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.packageForm, "is_wooden_packing", $$c);
        }
      }, _vm.onPackageWoodenPackingChange]
    }
  }), _vm._v(" Packing Kayu ")]), _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1"
  }, [_vm._v(" Jika aktif, wajib input dimensions. ")])]), !_vm.packageForm.is_wooden_packing ? _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('div', {
    staticClass: "flex gap-4"
  }, [_c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.packageForm.input_mode,
      expression: "packageForm.input_mode"
    }],
    attrs: {
      "type": "radio",
      "name": "input-mode",
      "value": "dims"
    },
    domProps: {
      "checked": _vm._q(_vm.packageForm.input_mode, "dims")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.packageForm, "input_mode", "dims");
      }
    }
  }), _vm._v(" Dimensions ")]), _c('label', {
    staticClass: "flex items-center gap-2 text-sm text-neutral-700"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.packageForm.input_mode,
      expression: "packageForm.input_mode"
    }],
    attrs: {
      "type": "radio",
      "name": "input-mode",
      "value": "manual"
    },
    domProps: {
      "checked": _vm._q(_vm.packageForm.input_mode, "manual")
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.packageForm, "input_mode", "manual");
      }
    }
  }), _vm._v(" Manual Weight ")])])]) : _vm._e(), _vm.shouldUseDims ? [_c('TextField', {
    attrs: {
      "label": "Length",
      "type": "number",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.packageForm.length,
      callback: function ($$v) {
        _vm.$set(_vm.packageForm, "length", $$v);
      },
      expression: "packageForm.length"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Width",
      "type": "number",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.packageForm.width,
      callback: function ($$v) {
        _vm.$set(_vm.packageForm, "width", $$v);
      },
      expression: "packageForm.width"
    }
  }), _c('TextField', {
    attrs: {
      "label": "Height",
      "type": "number",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.packageForm.height,
      callback: function ($$v) {
        _vm.$set(_vm.packageForm, "height", $$v);
      },
      expression: "packageForm.height"
    }
  })] : [_c('div', {
    staticClass: "md:col-span-2"
  }, [_c('TextField', {
    attrs: {
      "label": "Weight",
      "type": "number",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.packageForm.weight,
      callback: function ($$v) {
        _vm.$set(_vm.packageForm, "weight", $$v);
      },
      expression: "packageForm.weight"
    }
  }), _c('p', {
    staticClass: "text-xs text-neutral-500 mt-1"
  }, [_vm._v(" Jika Packing Kayu aktif, wajib input dimensions. ")])], 1)]], 2), _c('div', {
    staticClass: "flex justify-end gap-3 mt-6"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closePackageModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 disabled:cursor-not-allowed",
    attrs: {
      "disabled": !_vm.canSubmitPackage
    },
    on: {
      "click": _vm.submitPackage
    }
  }, [_vm._v(" Simpan ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deletePackageModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeletePackageModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v(" Delete Package ")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus package ini? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeletePackageModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDeletePackage
    }
  }, [_vm._v(" Hapus ")])])])])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h2', {
    staticClass: "text-lg font-bold text-neutral-800"
  }, [_vm._v("Packages")]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(" Tambah package dengan dimensi atau manual weight. ")])]);

}]

export { render, staticRenderFns }